import { environment } from '@env/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class PlansService {
    constructor(http) {
        this.http = http;
    }
    pixRequest(form) {
        return this.http.post(`${environment.base_url}/checkout/pix_request`, form);
    }
    creditRequest(form) {
        return this.http.post(`${environment.base_url}/checkout/credit_request`, form);
    }
    getChosenPlan() {
        return this.chosenPlan;
    }
    setChosenPlan(plan) {
        this.chosenPlan = plan;
    }
    parseMonthsToDays(months) {
        switch (months) {
            case 12:
                return 365;
            default:
                return months * 30;
        }
    }
    get() {
        return this.http.get(`${environment.base_url}/checkout`);
    }
    processPayment(data) {
        return this.http.post(`${environment.base_url}/checkout/process_payment`, data);
    }
    processBoletoPayment(data) {
        return this.http.post(`${environment.base_url}/checkout/process_boleto_payment`, data);
    }
    getLastBoletoLink() {
        return this.http.get(`${environment.base_url}/checkout/get_last_boleto_link`);
    }
    sendReceipt(formData) {
        return this.http.post(`${environment.base_url}/checkout/send_receipt`, formData, {
            reportProgress: true,
            observe: 'events'
        });
    }
    sendWordsReceipt(formData) {
        return this.http.post(`${environment.base_url}/checkout/send_words_receipt`, formData, {
            reportProgress: true,
            observe: 'events'
        });
    }
}
PlansService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PlansService_Factory() { return new PlansService(i0.ɵɵinject(i1.HttpClient)); }, token: PlansService, providedIn: "root" });
